.month-view {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  height: 100%;
  min-height: 0;
}

.weekday-header {
  --height: 38px;

  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  flex: 0 0 var(--height);
  height: var(--height);
  border-bottom: var(--rc-calendar-border-base);
  background-color: var(--rc-calendar-color-surface-default);
}

.weekday {
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: var(--rc-calendar-spacing-xs) var(--rc-calendar-spacing-ms);
  border-right: var(--rc-calendar-border-base);
  color: var(--rc-calendar-color-text-default);
  font-size: var(--rc-calendar-font-size-text-base);
}

.grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  flex: 1;
  min-height: 0;
}
